export enum AssetLocationTypeId {
  General = 1,
  Clean = 2,
  Soiled = 3,
  Storage = 4,
  Patient_Room = 5,
}
